import React from 'react';
import ReactDOM from 'react-dom/client';
// import '../config-overrides';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-range-slider-input/dist/style.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';
import 'rc-checkbox/assets/index.css';

import App from './App';
import { GoogleOAuthProvider} from '@react-oauth/google';
import { SocketContextProvider } from './common/SocketService';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId="">
    <SocketContextProvider>
      <App />
    </SocketContextProvider>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App /> 
//   </React.StrictMode>,
//   document.getElementById('root')
// );